import React, { useEffect, useState } from "react";
import ContctList from "./ContctList";
import { Form } from "antd";
import Banner from "../../../views/components/sections/Banner";
import { useMessageApi } from "../../../provider/AntdNotification";
import { useQueryState } from "nuqs";
import { usePageDetail, usePageSave } from "../../../hooks/api/pages/hooks";
import TabsContain from "../../../views/components/reuseComp/TabsContain";
import { getSingleImageUrl } from "../../../lib/utils";
import { IContactPagePagePayload, IPagePayload } from "@src/types/api/pages";
import ContactDetail from "./contactDetails";

const ContactTabs: React.FC<{
  setBreadcrumb: (breadcrumb: string) => void;
}> = ({ setBreadcrumb }) => {
  const message = useMessageApi();
  const [tab, setTab] = useQueryState("tab");
  const activeTab = tab || "Banner";
  const [isEditing, setIsEditing] = useState(false);
  const [pageData, setPageData] = useState<any>(null);
  const { data } = usePageDetail("CONTACT");
  const { mutate: updateContact, isPending } = usePageSave({});

  useEffect(() => {
    if (data?.data) setPageData(data.data);
  }, [data]);

  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsEditing(false);
    form.resetFields();
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      let payload: IContactPagePagePayload = {
        _id: pageData?._id,
        pageType: "CONTACT",
        banner: pageData?.banner || {
          heading: "",
          image: "",
        },
        contact: {
          email: "",
          phone: "",
          address: "",
          formTitle: "",
          location: "",
        },
      };

      if (values.banner) {
        payload.banner = {
          heading: values.banner.heading,
          image: getSingleImageUrl(values.banner?.image),
        };
      }

      if (values.contact) {
        payload.contact = {
          email: values.contact.email,
          phone: values.contact.phone,
          address: values.contact.address,
          formTitle: values.contact.formTitle,
          location: values.contact.location,
        };
      }

      updateContact(payload, {
        onSuccess: (res) => {
          message.success("Page updated successfully");
          setPageData(res.data);
          setIsEditing(false);
        },
        onError: () => {
          message.error("Failed to update page");
        },
      });
    } catch (error) {
      console.log("❌ Validation failed:", error);
    }
  };

  const sections = ["Banner", "Details", "Enquiry"];

  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
  };

  return (
    <div>
      <TabsContain
        handleChangeTab={handleChangeTab}
        activeTab={activeTab}
        sections={sections}
      />
      {activeTab === "Banner" && (
        <Banner
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          bannerData={pageData?.banner}
          loading={isPending}
        />
      )}

      {activeTab === "Details" && (
        <ContactDetail
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          contactData={pageData?.contact}
          loading={isPending}
        />
      )}

      {activeTab === "Enquiry" && <ContctList />}
    </div>
  );
};

export default ContactTabs;
